import css from '@styled-system/css';
import styled from 'styled-components';

import { translate } from '../../common/helpers/translate.helper';
import { Box } from '../../common/ui/Box';

const InfoBox = styled(Box)(
    css({
        padding: '10px',
        textAlign: 'center',
        fontWeight: 300,
        fontSize: '12',
        color: 'black',
        lineHeight: 18,
        backgroundColor: 'background.subtle',
    })
);

export const OfferChatInfo = ({ showForwardedOfferInfoText, showInfoText }) => {
    if (showForwardedOfferInfoText) {
        return <InfoBox>{translate('order.forwardedOfferMessageInfo')}</InfoBox>;
    }

    if (showInfoText) {
        return <InfoBox>{translate('order.suppliermessageinfo')}</InfoBox>;
    }

    return null;
};
